import config from 'src/config'

function load(component) {
  return () => import(`src/${component}.vue`)
}

const MODULE_PATH = '/ewallet/management/'

export default [
  {
    path: MODULE_PATH,
    component: load('containers/Full'),
    name: 'e-Wallet',
    meta: {
      title: 'Common.menu.wallet_management',
      menuItem: true,
      sorting: config.sidebar.menu.sorting.modules.ewallet,
      icon: 'account_balance_wallet',
    },
    children: [
      {
        path: MODULE_PATH + 'adjustment/list',
        component: load('application/ewallet/components/eWalletAdjustmentList'),
        name: 'e-Wallet Adjustment List',
        meta: {
          title: 'e-Wallet Adjustment',
          icon: 'attach_money',
          menuItem: true,
          sorting: 1001,
        },
      },
      {
        path: MODULE_PATH + 'adjustment/details/[:adjustmentID]',
        component: load('application/ewallet/components/eWalletAdjustmentDetail'),
        name: 'e-Wallet Adjustment Detail',
        props: true,
        meta: {
          title: 'e-Wallet Adjustment Detail',
          icon: 'attach_money',
          menuItem: false,
          sorting: 1002,
        },
      },
      {
        path: MODULE_PATH + 'adjustment/new',
        component: load('application/ewallet/components/eWalletAdjustmentDetail'),
        name: 'New e-Wallet Adjustment',
        meta: {
          title: 'New e-Wallet Adjustment',
          icon: 'attach_money',
          menuItem: false,
          sorting: 1003,
        },
      },
      {
        path: MODULE_PATH + 'giro/payment/list',
        component: load('application/ewallet/components/eWalletGiroPaymentList'),
        name: 'e-Wallet GIRO Payment List',
        meta: {
          title: 'e-Wallet GIRO Payment List',
          icon: 'attach_money',
          menuItem: true,
          sorting: 1004,
        },
      },
      {
        path: MODULE_PATH + 'giro/payment/generation',
        component: load('application/ewallet/components/eWalletGiroPaymentGeneration'),
        name: 'e-Wallet GIRO Payment Generation',
        meta: {
          title: 'e-Wallet GIRO Payment Generation',
          icon: 'attach_money',
          menuItem: true,
          sorting: 1005,
        },
      },
      {
        path: MODULE_PATH + 'giro/payment/rejected/list',
        component: load('application/ewallet/components/eWalletGiroRejectedPayment'),
        name: 'e-Wallet Giro Payment Bulk Upload',
        meta: {
          title: 'e-Wallet Giro Payment Bulk Upload',
          icon: 'attach_money',
          menuItem: true,
          sorting: 1006,
        },
      },
      {
        path: MODULE_PATH + 'giro/payment/rejected/new',
        component: load('application/ewallet/components/eWalletGiroRejectedUploadReview'),
        name: 'e-Wallet GIRO Rejected Upload Review',
        meta: {
          title: 'e-Wallet GIRO Payment Bulk Upload Review',
          icon: 'attach_money',
          menuItem: false,
          sorting: 1007,
        },
      },
      {
        path: MODULE_PATH + 'member/transaction/list',
        component: load('application/ewallet/components/eWalletTransactionsList'),
        name: 'e-Wallet Members Transactions',
        meta: {
          title: 'e-Wallet Members Transactions',
          icon: 'face',
          menuItem: true,
          sorting: 1008,
        },
      },
      {
        path: MODULE_PATH + 'member/transaction/details/[:transactionID]',
        component: load('application/ewallet/components/eWalletTransactionArea'),
        name: 'e-Wallet Member Transaction Details',
        props: true,
        meta: {
          title: 'e-Wallet Member Transaction Details',
          icon: 'attach_money',
          menuItem: false,
          sorting: 1002,
        },
      },
      {
        path: MODULE_PATH + 'member/transaction/new',
        component: load('application/ewallet/components/eWalletTransactionArea'),
        name: 'New e-Wallet Member Transaction',
        meta: {
          title: 'New e-Wallet Member Transaction',
          icon: 'attach_money',
          menuItem: false,
          sorting: 1003,
        },
      },
    ],
  },
]
